import { map, indexOf } from 'lodash';

export default function getFilterOptions(options, selected) {
  return map(options, (option) => ({
    label: option.display_name,
    value: option.value,
    initial: indexOf(selected, option.value) >= 0,
  }), []);
}
